import ListView from '@ingka/list-view';

import { PriceSummaryOverviewEntry } from './price-summary-overview-entry.component';
import { usePriceSummaryOverviewTotalEntries } from './price-summary-overview-totals-list.hooks';

import styles from '../../styles.module.scss';

export const PriceSummaryOverviewTotalsList = () => {
    const entries = usePriceSummaryOverviewTotalEntries();

    return (
        <ListView className={styles.asset_price_summary_list ?? ''} id="price-totals" size="small" showDivider={false}>
            {entries.map((entry) => (
                <PriceSummaryOverviewEntry {...entry} key={entry.id} />
            ))}
        </ListView>
    );
};
